import React, { createContext, useContext } from "react";

/**
 * Class names that re-colour the game-blue interaction components inside a
 * subtree (see `.pi-scope-key-blue` in style.css). CSS alone reaches everything
 * rendered inside the subtree; menus that portal into <body> read this context and
 * add the same class to their own root.
 */
const PiColorScopeContext = createContext<string>("");

export function usePiColorScope() {
  return useContext(PiColorScopeContext);
}

/** Editor key blue for the game-blue components below it, portalled menus included. */
export function PiKeyBlueScope(props: { children: React.ReactNode }) {
  return (
    <PiColorScopeContext.Provider value="pi-scope-key-blue">
      {props.children}
    </PiColorScopeContext.Provider>
  );
}
